<template>
  <div class="ps-time-picker">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="model"
          readonly
          v-bind="attrs"
          v-on="on"
          :placeholder="placeholder"
          :outlined="outlined"
          :dense="dense"
          :disabled="disabled"
          :hide-details="hideDetails"
          :error-messages="errorMessages"
          single-line
        >
          <template v-slot:append>
            <v-icon small>fal fa-clock</v-icon>
          </template>
        </v-text-field>
      </template>
      <v-time-picker
        v-if="menu"
        v-model="model"
        format="24hr"
        no-title
        scrollable
        @click:minute="$refs.menu.save(model)"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: { type: String, default: "" },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    errorMessages: { type: Array, require: true },
  },
  data() {
    return {
      menu: false,
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  computed: {
    hideDetails() {
      if (this.errorMessages && this.errorMessages.length) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.ps-time-picker ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center !important;
}
</style>
